// src/components/MainHeader/index.jsx
import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  contactsHeader: {
    display: "flex",
    flexDirection: "column", // Quebra em coluna no mobile
    justifyContent: "flex-start",
    padding: "0px 6px 6px 6px",
    width: "100%",
    boxSizing: "border-box",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between", // Separa título e botões
    },
  },
}));

const MainHeader = ({ children }) => {
  const classes = useStyles();

  return <div className={classes.contactsHeader}>{children}</div>;
};

export default MainHeader;